"use strict";

/* -------------------------------------------------------------------------

	PUNITED.top

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.top) PUNITED.top = {};
var createjs, AdobeAn;
var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.top;

  ns.intro = function (tl) {
    (function (cjs, an) {
      var p; // shortcut to reference prototypes

      var lib = {};
      var ss = {};
      var img = {};
      lib.ssMetadata = [{
        name: "opening_atlas_1",
        frames: [[0, 0, 1772, 779]]
      }];
      (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;

        this.gotoAndPlay = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };

        this.play = function () {
          cjs.MovieClip.prototype.play.call(this);
        };

        this.gotoAndStop = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };

        this.stop = function () {
          cjs.MovieClip.prototype.stop.call(this);
        };
      }).prototype = p = new cjs.MovieClip(); // symbols:

      (lib.CachedBmp_1 = function () {
        this.initialize(ss["opening_atlas_1"]);
        this.gotoAndStop(0);
      }).prototype = p = new cjs.Sprite(); // helper functions:

      function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
      }

      function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
      }

      (lib.トゥイーン2 = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.lf(["#00A3F0", "#101C80"], [0, 1], 0, 101.9, 0, -101.8).s().p("AtIPgISh+/IHwAAIyge/g");
        this.shape.setTransform(-70.4, 83.05, 0.837, 0.837, 0, 0, 0, -84.1, 99.2);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = p = new cjs.MovieClip();
      p.nominalBounds = new cjs.Rectangle(-70.4, -83, 140.8, 166.1);
      (lib.トゥイーン1 = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.lf(["#00A3F0", "#101C80"], [0, 1], 0, 85.3, 0, -85.2).s().p("Aq/M/IPg59IGfAAIvgZ9g");
        this.shape.setTransform(-70.4, 83, 1, 1, 0, 0, 0, -70.4, 83);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = p = new cjs.MovieClip();
      p.nominalBounds = new cjs.Rectangle(-70.4, -83, 140.8, 166.1);
      (lib.NCTlogo = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = false;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.instance = new lib.CachedBmp_1();
        this.instance.setTransform(0, 0, 0.5, 0.5);
        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.NCTlogo, new cjs.Rectangle(0, 0, 886, 389.5), null); // stage content:

      (lib.opening = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = false;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // line

        this.instance = new lib.トゥイーン1("synched", 0);
        this.instance.setTransform(170.95, 88.9);
        this.instance.alpha = 0;
        this.instance_1 = new lib.トゥイーン2("synched", 0);
        this.instance_1.setTransform(71.8, 255);
        this.instance_1._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance).to({
          x: 71.8,
          y: 255,
          alpha: 1
        }, 9).to({
          _off: true
        }, 10).wait(16));
        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(19).to({
          _off: false
        }, 0).to({
          x: 430.15,
          y: 253.7
        }, 10).to({
          x: 549.6,
          y: 253.3,
          alpha: 0
        }, 5).wait(1)); // レイヤー_1 (mask)

        var mask = new cjs.Shape();
        mask._off = true;
        var mask_graphics_21 = new cjs.Graphics().p("EgoFAagIP66mMBARAAAIv7amg");
        var mask_graphics_22 = new cjs.Graphics().p("EgoFAahIP66nMBARAAAIv7ang");
        var mask_graphics_23 = new cjs.Graphics().p("EgoFAahIP66mMBARAAAIv7amg");
        var mask_graphics_24 = new cjs.Graphics().p("EgoFAaiIP66nMBARAAAIv7ang");
        var mask_graphics_25 = new cjs.Graphics().p("EgoFAaiIP66mMBARAAAIv7amg");
        var mask_graphics_26 = new cjs.Graphics().p("EgoFAajIP66nMBARAAAIv7ang");
        var mask_graphics_27 = new cjs.Graphics().p("EgoFAajIP66mMBARAAAIv7amg");
        var mask_graphics_28 = new cjs.Graphics().p("EgoFAakIP66nMBARAAAIv7ang");
        var mask_graphics_29 = new cjs.Graphics().p("EgoFAakIP66mMBARAAAIv7amg");
        var mask_graphics_30 = new cjs.Graphics().p("EgoFAalIP66nMBARAAAIv7ang");
        var mask_graphics_31 = new cjs.Graphics().p("EgoFAalIP66mMBARAAAIv7amg");
        var mask_graphics_32 = new cjs.Graphics().p("EgmhAamIP66nMBAQAAAIv6ang");
        var mask_graphics_33 = new cjs.Graphics().p("EgkFAamIP56mMBARAAAIv7amg");
        var mask_graphics_34 = new cjs.Graphics().p("EghqAanIP56nMBARAAAIv6ang");
        this.timeline.addTween(cjs.Tween.get(mask).to({
          graphics: null,
          x: 0,
          y: 0
        }).wait(21).to({
          graphics: mask_graphics_21,
          x: -64.9009,
          y: 169.5959
        }).wait(1).to({
          graphics: mask_graphics_22,
          x: -33.8624,
          y: 169.6498
        }).wait(1).to({
          graphics: mask_graphics_23,
          x: -2.824,
          y: 169.7036
        }).wait(1).to({
          graphics: mask_graphics_24,
          x: 28.2145,
          y: 169.7575
        }).wait(1).to({
          graphics: mask_graphics_25,
          x: 59.253,
          y: 169.8113
        }).wait(1).to({
          graphics: mask_graphics_26,
          x: 90.2914,
          y: 169.8652
        }).wait(1).to({
          graphics: mask_graphics_27,
          x: 121.3299,
          y: 169.919
        }).wait(1).to({
          graphics: mask_graphics_28,
          x: 152.3684,
          y: 169.9729
        }).wait(1).to({
          graphics: mask_graphics_29,
          x: 183.4068,
          y: 170.0267
        }).wait(1).to({
          graphics: mask_graphics_30,
          x: 214.4453,
          y: 170.0805
        }).wait(1).to({
          graphics: mask_graphics_31,
          x: 245.4837,
          y: 170.1344
        }).wait(1).to({
          graphics: mask_graphics_32,
          x: 266.5366,
          y: 170.1882
        }).wait(1).to({
          graphics: mask_graphics_33,
          x: 282.0558,
          y: 170.2421
        }).wait(1).to({
          graphics: mask_graphics_34,
          x: 297.575,
          y: 170.2959
        }).wait(1)); // logo

        this.instance_2 = new lib.NCTlogo();
        this.instance_2.setTransform(105.25, 336.45, 0.4176, 0.4175, 0, 0, 0, 0, 389.8);
        this.instance_2._off = true;
        var maskedShapeInstanceList = [this.instance_2];

        for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
          maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(21).to({
          _off: false
        }, 0).wait(14));

        this._renderFirstFrame();
      }).prototype = p = new lib.AnMovieClip();
      p.nominalBounds = new cjs.Rectangle(311.4, 260.9, 308.6, 77.20000000000005); // library properties:

      lib.properties = {
        id: '8271D446ADD94F3EBF76D3875323A7CB',
        width: 620,
        height: 510,
        fps: 24,
        color: "#FFFFFF",
        opacity: 1.00,
        manifest: [{
          src: "/assets/img/common/opening_atlas_1.png",
          id: "opening_atlas_1"
        }],
        preloads: []
      }; // bootstrap callback support:

      (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
      }).prototype = p = new createjs.Stage();

      p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
      };

      p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
      };

      p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
      };

      p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
      };

      p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
      };

      p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
      };

      an.bootcompsLoaded = an.bootcompsLoaded || [];

      if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
      }

      an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);

        if (an.bootcompsLoaded.length > 0) {
          for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
            fnCallback(an.bootcompsLoaded[i]);
          }
        }
      };

      an.compositions = an.compositions || {};
      an.compositions['8271D446ADD94F3EBF76D3875323A7CB'] = {
        getStage: function getStage() {
          return exportRoot.stage;
        },
        getLibrary: function getLibrary() {
          return lib;
        },
        getSpriteSheet: function getSpriteSheet() {
          return ss;
        },
        getImages: function getImages() {
          return img;
        }
      };

      an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);

        for (var j = 0; j < an.bootstrapListeners.length; j++) {
          an.bootstrapListeners[j](id);
        }
      };

      an.getComposition = function (id) {
        return an.compositions[id];
      };

      an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW,
            lastH,
            lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        function resizeCanvas() {
          var w = lib.properties.width,
              h = lib.properties.height;
          var iw = window.innerWidth,
              ih = window.innerHeight;
          var pRatio = window.devicePixelRatio || 1,
              xRatio = iw / w,
              yRatio = ih / h,
              sRatio = 1;

          if (isResp) {
            if (respDim == 'width' && lastW == iw || respDim == 'height' && lastH == ih) {
              sRatio = lastS;
            } else if (!isScale) {
              if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 1) {
              sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 2) {
              sRatio = Math.max(xRatio, yRatio);
            }
          }

          domContainers[0].width = w * pRatio * sRatio;
          domContainers[0].height = h * pRatio * sRatio;
          domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
          });
          stage.scaleX = pRatio * sRatio;
          stage.scaleY = pRatio * sRatio;
          lastW = iw;
          lastH = ih;
          lastS = sRatio;
          stage.tickOnUpdate = false;
          stage.update();
          stage.tickOnUpdate = true;
        }
      };

      an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
          var stageChild = stage.getChildAt(0);

          if (!stageChild.paused || stageChild.ignorePause) {
            stageChild.syncStreamSounds();
          }
        }
      };

      an.handleFilterCache = function (event) {
        if (!event.paused) {
          var target = event.target;

          if (target) {
            if (target.filterCacheList) {
              for (var index = 0; index < target.filterCacheList.length; index++) {
                var cacheInst = target.filterCacheList[index];

                if (cacheInst.startFrame <= target.currentFrame && target.currentFrame <= cacheInst.endFrame) {
                  cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                }
              }
            }
          }
        }
      };
    })(createjs = createjs || {}, AdobeAn = AdobeAn || {});

    function handleFileLoad(evt, comp) {
      var images = comp.getImages();

      if (evt && evt.item.type == "image") {
        images[evt.item.id] = evt.result;
      }
    }

    function handleComplete(evt, comp) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib = comp.getLibrary();
      var ss = comp.getSpriteSheet();
      var queue = evt.target;
      var ssMetadata = lib.ssMetadata;

      for (var i = 0; i < ssMetadata.length; i++) {
        ss[ssMetadata[i].name] = new createjs.SpriteSheet({
          "images": [queue.getResult(ssMetadata[i].name)],
          "frames": ssMetadata[i].frames
        });
      }

      exportRoot = new lib.opening();
      stage = new lib.Stage(canvas); //Registers the "tick" event listener.

      fnStartAnimation = function fnStartAnimation() {
        stage.addChild(exportRoot);
        createjs.Ticker.framerate = lib.properties.fps;
        createjs.Ticker.addEventListener("tick", stage);
      }; //Code to support hidpi screens and responsive scaling.


      AdobeAn.makeResponsive(true, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
      AdobeAn.compositionLoaded(lib.properties.id);
      tl.resume();
    }

    canvas = document.getElementById("canvas");
    anim_container = document.getElementById("animation_container");
    dom_overlay_container = document.getElementById("dom_overlay_container");
    var comp = AdobeAn.getComposition("8271D446ADD94F3EBF76D3875323A7CB");
    var loader = new createjs.LoadQueue(false);
    loader.addEventListener("fileload", function (evt) {
      handleFileLoad(evt, comp);
    });
    loader.addEventListener("complete", function (evt) {
      handleComplete(evt, comp);
    });
    var lib = comp.getLibrary();
    loader.loadManifest(lib.properties.manifest);
  };
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */


  ns.slide = function () {
    var scroll = document.querySelector('.top_main__scroll');
    var slider = document.getElementById('top_main_slider');
    var firstSlide = slider.querySelector('.top_main__slide.--slide_01');
    var firstImg = firstSlide.querySelector('.top_main__slide_bg img');
    var firstTitle = firstSlide.querySelector('.top_main__slide_title');
    var linePath = firstSlide.querySelector('.top_main__slide_pc_line path');
    var slideSpeed = 2000;
    var slideDelay = 3000;
    var splide = new Splide(slider, {
      type: 'fade',
      rewind: true,
      speed: slideSpeed,
      easing: 'ease',
      interval: slideSpeed + slideDelay,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      arrows: false
    });
    splide.mount();
    var Autoplay = splide.Components.Autoplay;
    Autoplay.pause();
    var tl = gsap.timeline({
      paused: true,
      delay: .5,
      onStart: function onStart() {
        gsap.set(linePath, {
          opacity: 1
        });
      },
      onComplete: function onComplete() {
        linePath.classList.add('--played');
        scroll.classList.remove('--paused');
        Autoplay.play();
      }
    }).to(firstTitle, {
      opacity: 1
    }).to(linePath, {
      'stroke-dashoffset': function strokeDashoffset() {
        return ns.getLineLength(linePath) * -2 + 1;
      },
      duration: 1,
      ease: 'power3.out'
    });
    ns.slideLinePc(tl);
    var introContainer = document.querySelector('.page_intro');
    var introContent = introContainer.querySelector('.page_intro__content');
    var key = "introPlayedAt";
    var duration = 1000 * 60 * 60 * 24;
    var lastPlayedAt = parseInt(window.localStorage.getItem(key), 10) || 0;
    var now = Date.now();

    if (lastPlayedAt + duration < now) {
      window.localStorage.setItem(key, "".concat(Date.now()));
      PUNITED.utils.preventScroll();
      var introTl = gsap.timeline({
        delay: .5,
        paused: true,
        onStart: function onStart() {
          fnStartAnimation();
        },
        onComplete: function onComplete() {
          PUNITED.utils.allowScroll();
          revealSlider();
        }
      }).to(introContent, {
        display: 'block',
        duration: 4
      }, '<').to(introContainer, {
        opacity: 0,
        display: 'none'
      });
      ns.intro(introTl);
    } else {
      gsap.to(introContainer, {
        opacity: 0,
        display: 'none'
      });
      revealSlider();
    }

    function revealSlider() {
      if (firstImg.complete) {
        tl.play();
      } else {
        firstImg.addEventListener('load', function () {
          tl.play();
        });
      }
    }
  };

  ns.newsSlider = function () {
    new Splide('#top_main_news', {
      type: 'loop',
      direction: 'ttb',
      height: 28,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: false,
      breakpoints: {
        680: {
          height: 53
        }
      }
    }).mount();
  };

  ns.slideLinePc = function (timeline) {
    var lineContainers = document.querySelectorAll('.top_main__slide_pc_line');
    lineContainers.forEach(function (lineContainer) {
      var container = lineContainer.closest('.top_main__slide_fg');
      resizeLine(lineContainer, container);
      var observer = new ResizeObserver(function () {
        resizeLine(lineContainer, container);

        if (timeline.isActive()) {
          timeline.pause().invalidate().resume();
        }
      });
      observer.observe(container);
    });

    function resizeLine(lineContainer, container) {
      if (PUNITED.common.mediaQuery.matches) {
        resizeLineSp(lineContainer, container);
      } else {
        resizeLinePc(lineContainer, container);
      }
    }

    function resizeLinePc(lineContainer, container) {
      var svg = lineContainer.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = container.offsetWidth;
      var canvasHeight = container.offsetHeight;
      var ratioX = canvasWidth / 1340;
      var ratioY = canvasHeight / 654;
      var width = 640.021 * ratioX;
      var height = 612.916 * ratioY;
      var startPointX = -6712.762 * ratioX;
      var startPointY = -23044.164 * ratioY;
      var startControlPointX = 54.241 * ratioX;
      var startControlPointY = 14.535 * ratioY;
      var endControlPointX = 632.535 * ratioX;
      var endControlPointY = 182.158 * ratioY;
      var endPointX = 638.762 * ratioX;
      var endPointY = 611.936 * ratioY;
      var translateX = 6713.021 * ratioX;
      var translateY = 23045.131 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(startControlPointX, ",").concat(startControlPointY, " ").concat(endControlPointX, ",").concat(endControlPointY, " ").concat(endPointX, ",").concat(endPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
      path.style.strokeWidth = '2';
    }

    function resizeLineSp(lineContainer, container) {
      var svg = lineContainer.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = container.offsetWidth;
      var canvasHeight = container.offsetHeight;
      var ratioX = canvasWidth / 345;
      var ratioY = canvasHeight / 550;
      var width = 257.271 * ratioX;
      var height = 518.266 * ratioY;
      var startPointX = -6330.451 * ratioX;
      var startPointY = -23019.26 * ratioY;
      var startControlPoint1X = 100.265 * ratioX;
      var startControlPoint1Y = 20.506 * ratioY;
      var endControlPoint1X = 162.5 * ratioX;
      var endControlPoint1Y = 65.219 * ratioY;
      var endPoint1X = 200.455 * ratioX;
      var endPoint1Y = 128.078 * ratioY;
      var startControlPoint2X = 50.449 * ratioX;
      var startControlPoint2Y = 75.436 * ratioY;
      var endControlPoint2X = 59.968 * ratioX;
      var endControlPoint2Y = 231.67 * ratioY;
      var endPoint2X = 55.07 * ratioX;
      var endPoint2Y = 389.682 * ratioY;
      var translateX = 6330.551 * ratioX;
      var translateY = 23019.75 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(startControlPoint1X, ",").concat(startControlPoint1Y, " ").concat(endControlPoint1X, ",").concat(endControlPoint1Y, " ").concat(endPoint1X, ",").concat(endPoint1Y, " c ").concat(startControlPoint2X, ",").concat(startControlPoint2Y, " ").concat(endControlPoint2X, ",").concat(endControlPoint2Y, " ").concat(endPoint2X, ",").concat(endPoint2Y));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
      path.style.strokeWidth = '1';
    }
  };

  ns.pcBodyLine = function () {
    var linePc = document.querySelector('.top_pc_line');
    var path = linePc.querySelector('path');
    var aboutSection = document.getElementById('about');
    var aboutLine1 = aboutSection.querySelector('.top_sp_line.--item_01');
    var aboutLine2 = aboutSection.querySelector('.top_sp_line.--item_02');

    function resizeAboutLine1() {
      var svg = aboutLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 141.548 * 1;
      var height = 370.572 * ratioY;
      var startPointX = 9417.5 * 1;
      var startPointY = -20824 * ratioY;
      var startControlPointX = 0.683 * 1;
      var startControlPointY = 98.242 * ratioY;
      var endControlPointX = -1.376 * ratioX;
      var endControlPointY = 119.27 * ratioY;
      var endPointX = -63.771 * ratioX;
      var endPointY = 181.1 * ratioY;
      var sControlPointX = 103.114 * ratioX;
      var sControlPointY = 107.822 * ratioY;
      var sEndPointX = 126.794 * ratioX;
      var sEndPointY = 189.328 * ratioY;
      var translateX = -9339.456 * 1;
      var translateY = 20824.004 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(startControlPointX, ",").concat(startControlPointY, " ").concat(endControlPointX, ",").concat(endControlPointY, " ").concat(endPointX, ",").concat(endPointY, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    function resizeAboutLine2() {
      var svg = aboutLine2.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 451.252 * 1;
      var height = 340.686 * ratioY;
      var startPointX = 9473.862 * 1;
      var startPointY = -20349.682 * ratioY;
      var startControlPointX = -31.6 * 1;
      var startControlPointY = 130.965 * ratioY;
      var endControlPointX = -139.756 * ratioX;
      var endControlPointY = 143.84 * ratioY;
      var endPointX = -261.866 * ratioX;
      var endPointY = 185.51 * ratioY;
      var sControlPointX = -187.782 * ratioX;
      var sControlPointY = 87.918 * ratioY;
      var sEndPointX = -188.4 * ratioX;
      var sEndPointY = 155.055 * ratioY;
      var translateX = -9023.097 * 1;
      var translateY = 20349.799 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(startControlPointX, ",").concat(startControlPointY, " ").concat(endControlPointX, ",").concat(endControlPointY, " ").concat(endPointX, ",").concat(endPointY, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    var businessSection = document.getElementById('business');
    var businessLine1 = businessSection.querySelector('.top_sp_line.--item_01');

    function resizeBusinessLine1() {
      var svg = businessLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 496.068 * ratioX;
      var height = 577.521 * ratioY;
      var startPointX = 9015.672 * ratioX;
      var startPointY = -19747.885 * ratioY;
      var startControlPointX = 43.42 * ratioX;
      var startControlPointY = 86.834 * ratioY;
      var endControlPointX = 180.938 * ratioX;
      var endControlPointY = 138.453 * ratioY;
      var endPointX = 267.927 * ratioX;
      var endPointY = 260.813 * ratioY;
      var sControlPointX = 41.677 * ratioX;
      var sControlPointY = 190.2 * ratioY;
      var sEndPointX = 227.414 * ratioX;
      var sEndPointY = 316.072 * ratioY;
      var translateX = -9015.225 * ratioX;
      var translateY = 19748.107 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(startControlPointX, ",").concat(startControlPointY, " ").concat(endControlPointX, ",").concat(endControlPointY, " ").concat(endPointX, ",").concat(endPointY, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    var productsSection = document.getElementById('products');
    var companySection = document.getElementById('company');
    var companyLine1 = companySection.querySelector('.top_sp_line.--item_01');

    function resizeCompanyLine1() {
      var svg = companyLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 492.944 * ratioX;
      var height = 669.047 * ratioY;
      var startPointX = 9492.849 * ratioX;
      var startPointY = -18851.945 * ratioY;
      var sControlPoint1X = 28.269 * ratioX;
      var sControlPoint1Y = 175.836 * ratioY;
      var sEndPoint1X = -93.989 * ratioX;
      var sEndPoint1Y = 298.945 * ratioY;
      var sControlPointX = -388.962 * ratioX;
      var sControlPointY = 81.684 * ratioY;
      var sEndPointX = -395.125 * ratioX;
      var sEndPointY = 370.012 * ratioY;
      var translateX = -9003.234 * ratioX;
      var translateY = 18852.025 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " s ").concat(sControlPoint1X, ",").concat(sControlPoint1Y, " ").concat(sEndPoint1X, ",").concat(sEndPoint1Y, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    var magazineSection = document.getElementById('magazine');
    var magazineLine1 = magazineSection.querySelector('.top_sp_line.--item_01');

    function resizeMagazineLine1() {
      var svg = magazineLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = ratioX;
      var width = 564.193 * ratioX;
      var height = 476.193 * ratioY;
      var startPointX = 8931.864 * ratioX;
      var startPointY = -18005.709 * ratioY;
      var cStartControlPoint1X = 64.433 * ratioX;
      var cStartControlPoint1Y = 153.51 * ratioY;
      var cEndControlPoint1X = 82 * ratioX;
      var cEndControlPoint1Y = 239.625 * ratioY;
      var cEndPoint1X = 282.452 * ratioX;
      var cEndPoint1Y = 267.857 * ratioY;
      var cStartControlPoint2X = 331.832 * ratioX;
      var cStartControlPoint2Y = 57.213 * ratioY;
      var cEndControlPoint2X = 110.059 * ratioX;
      var cEndControlPoint2Y = -339.125 * ratioY;
      var cEndPoint2X = -38.723 * ratioX;
      var cEndPoint2Y = -184.645 * ratioY;
      var sControlPointX = 348.108 * ratioX;
      var sControlPointY = 317.057 * ratioY;
      var sEndPointX = 318.271 * ratioX;
      var sEndPointY = 392.6 * ratioY;
      var translateX = -8931.403 * ratioX;
      var translateY = 18005.902 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(cStartControlPoint1X, ",").concat(cStartControlPoint1Y, " ").concat(cEndControlPoint1X, ",").concat(cEndControlPoint1Y, " ").concat(cEndPoint1X, ",").concat(cEndPoint1Y, " c ").concat(cStartControlPoint2X, ",").concat(cStartControlPoint2Y, " ").concat(cEndControlPoint2X, ",").concat(cEndControlPoint2Y, " ").concat(cEndPoint2X, ",").concat(cEndPoint2Y, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    var newsSection = document.getElementById('news');
    var newsLine1 = newsSection.querySelector('.top_sp_line.--item_01');

    function resizeNewsLine1() {
      var svg = newsLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 607.184 * ratioX;
      var height = 899.191 * ratioY;
      var startPointX = 9013.516 * ratioX;
      var startPointY = -16316.773 * ratioY;
      var cStartControlPoint1X = 20.894 * ratioX;
      var cStartControlPoint1Y = -114.957 * ratioY;
      var cEndControlPoint1X = 227.639 * ratioX;
      var cEndControlPoint1Y = -118.365 * ratioY;
      var cEndPoint1X = 325.492 * ratioX;
      var cEndPoint1Y = -231.689 * ratioY;
      var sControlPoint1X = 123.435 * ratioX;
      var sControlPoint1Y = -192.746 * ratioY;
      var sEndPoint1X = 159.4 * ratioX;
      var sEndPoint1Y = -404.537 * ratioY;
      var sControlPointX = 121.545 * ratioX;
      var sControlPointY = -262.445 * ratioY;
      var sEndPointX = 121.545 * ratioX;
      var sEndPointY = -262.445 * ratioY;
      var translateX = -9013.023 * ratioX;
      var translateY = 17215.875 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " c ").concat(cStartControlPoint1X, ",").concat(cStartControlPoint1Y, " ").concat(cEndControlPoint1X, ",").concat(cEndControlPoint1Y, " ").concat(cEndPoint1X, ",").concat(cEndPoint1Y, " s ").concat(sControlPoint1X, ",").concat(sControlPoint1Y, " ").concat(sEndPoint1X, ",").concat(sEndPoint1Y, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "".concat(path.classList.contains('--played') ? length * 2 + 1 : length);
    }

    var recruitSection = document.getElementById('recruit');
    var recruitLine1 = recruitSection.querySelector('.top_sp_line.--item_01');

    function resizeRecruitLine1() {
      var svg = recruitLine1.querySelector('svg');
      var path = svg.querySelector('path');
      var canvasWidth = window.innerWidth;
      var canvasHeight = window.innerHeight;
      var ratioX = canvasWidth / 375;
      var ratioY = 1;
      var width = 412.52 * ratioX;
      var height = 371.97 * ratioY;
      var startPointX = 9012.433 * ratioX;
      var startPointY = -16077.115 * ratioY;
      var sControlPoint1X = 48.381 * ratioX;
      var sControlPoint1Y = 64.915 * ratioY;
      var sEndPoint1X = 154.01 * ratioX;
      var sEndPoint1Y = 113.364 * ratioY;
      var sControlPoint2X = 262.571 * ratioX;
      var sControlPoint2Y = 82.657 * ratioY;
      var sEndPoint2X = 257.49 * ratioX;
      var sEndPoint2Y = 150.354 * ratioY;
      var sControlPointX = -183.088 * ratioX;
      var sControlPointY = 93.183 * ratioY;
      var sEndPointX = -184.01 * ratioX;
      var sEndPointY = 107.921 * ratioY;
      var translateX = -9012.031 * ratioX;
      var translateY = 16077.414 * ratioY;
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
      path.setAttribute('d', "M ".concat(startPointX, ",").concat(startPointY, " s ").concat(sControlPoint1X, ",").concat(sControlPoint1Y, " ").concat(sEndPoint1X, ",").concat(sEndPoint1Y, " s ").concat(sControlPoint2X, ",").concat(sControlPoint2Y, " ").concat(sEndPoint2X, ",").concat(sEndPoint2Y, " s ").concat(sControlPointX, ",").concat(sControlPointY, " ").concat(sEndPointX, ",").concat(sEndPointY));
      path.setAttribute('transform', "translate(".concat(translateX, " ").concat(translateY, ")"));
      var length = ns.getLineLength(path);
      path.style.strokeDasharray = "".concat(length);
      path.style.strokeDashoffset = "-".concat(path.classList.contains('--played') ? length * 2 - 1 : length);
    }

    var triggersPc = [];
    var prevWidth = window.innerWidth;
    var timeline;
    resizeLineSp();
    window.addEventListener('resize', function () {
      var currentWidth = window.innerWidth;

      if (currentWidth === prevWidth) {
        return;
      }

      resizeLineSp();
    });
    window.addEventListener('orientationchange', _.debounce(function () {
      resizeLineSp();
    }, 250));
    init(PUNITED.common.mediaQuery.matches);
    PUNITED.common.mediaQuery.addEventListener('change', function (e) {
      init(e.matches);
    });

    function init(isSp) {
      var _timeline;

      triggersPc.forEach(function (trigger) {
        return trigger.kill();
      });
      triggersPc = [];
      (_timeline = timeline) === null || _timeline === void 0 ? void 0 : _timeline.kill();

      if (isSp) {
        timeline = gsap.timeline({// paused: true
        });
        triggersPc.push(ScrollTrigger.create({
          trigger: aboutSection,
          start: "top bottom",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, aboutLine1);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: aboutSection,
          start: "bottom bottom",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, aboutLine2);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: businessSection,
          start: "bottom 75%",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, businessLine1);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: companySection,
          start: "center bottom",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, companyLine1);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: magazineSection,
          start: "top center",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, magazineLine1, 2);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: newsSection,
          start: "bottom 75%",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, newsSection, 1.5, -1);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: recruitSection,
          start: "bottom bottom",
          end: "+=0",
          onEnter: function onEnter() {
            playLineSp(timeline, recruitLine1);
          },
          once: true // markers: true

        }));
      } else {
        var mY = 100;
        var aboutY = 80 + 516;
        var businessY = aboutY + mY * 2 + 124 + 629;
        var productY = businessY + mY + 765;
        var companyY = productY + mY + 688;
        var magazineY = companyY + mY + 582;
        var newsY = magazineY + mY + 418;
        var recruitY = newsY + mY + 476 + 200;
        triggersPc.push(ScrollTrigger.create({
          trigger: aboutSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(aboutY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: businessSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(businessY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: productsSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(productY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: companySection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(companyY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: magazineSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(magazineY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: newsSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(newsY);
          },
          once: true // markers: true

        }));
        triggersPc.push(ScrollTrigger.create({
          trigger: recruitSection,
          start: "75% bottom",
          end: "+=0",
          onEnter: function onEnter() {
            increaseLineLength(recruitY);
          },
          once: true // markers: true

        }));
      }
    }

    function increaseLineLength(height) {
      var totalHeight = 5184;
      var progress = height / totalHeight;
      var lineLength = ns.getLineLength(path);
      path.style.opacity = '1';
      path.style.strokeDasharray = "".concat(lineLength);
      path.style.strokeDashoffset = "-".concat(lineLength - 1 + lineLength * progress);
    }

    function playLineSp(timeline, line) {
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.5;
      var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var path = line.querySelector('path');

      if (path.classList.contains('--played')) {
        return;
      }

      path.classList.add('--played');
      path.style.opacity = '1';
      timeline.to(path, {
        'stroke-dashoffset': function strokeDashoffset() {
          return ns.getLineLength(path) * (-2 * direction) + direction;
        },
        duration: duration,
        ease: 'power3.out'
      });
    }

    function resizeLineSp() {
      if (PUNITED.common.mediaQuery.matches) {
        resizeAboutLine1();
        resizeAboutLine2();
        resizeBusinessLine1();
        resizeCompanyLine1();
        resizeMagazineLine1();
        resizeNewsLine1();
        resizeRecruitLine1();
      }
    }
  };
  /* -----------------------------------------------------
  	Wrapper for path.getTotalLength()
  	Round the result of getTotalLength() because Safari will screw you over if you use decimal value in stroke
  ----------------------------------------------------- */


  ns.getLineLength = function (line) {
    return Math.floor(line.getTotalLength());
  };
})();

$(function () {
  PUNITED.top.slide();
  PUNITED.top.newsSlider();
  PUNITED.top.pcBodyLine();
});